var map = {
	"./bg.ts": [
		"d5ca",
		"locale-bg-ts"
	],
	"./en.ts": [
		"d1ee",
		"locale-en-ts"
	],
	"./es.ts": [
		"0029",
		"locale-es-ts"
	],
	"./it.ts": [
		"75ac",
		"locale-it-ts"
	],
	"./ja.ts": [
		"ac58",
		"locale-ja-ts"
	],
	"./pt.ts": [
		"1a59",
		"locale-pt-ts"
	],
	"./ru.ts": [
		"39c9",
		"locale-ru-ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "a3c1";
module.exports = webpackAsyncContext;